import RevaText from "components/common/RevaText";
import { Illustration } from "components/common/Illustration";
import { Box, Button, Container, useTheme } from "@mui/material";

export default function ErrorPage() {
  const theme = useTheme();
  return (
    <Container sx={{ py: 16 }} maxWidth="md">
      <Box position="relative">
        <Illustration
          sx={{
            position: "absolute",
            inset: 0,
            opacity: 0.25,
            color: theme.palette.background.paper,
            width: "100%",
            height: "auto",
          }}
        />
        <Box sx={{ pt: { xs: 15, sm: 27.5 } }} position="relative" textAlign="center" justifyItems="center" zIndex={1}>
          <RevaText variant="h1" color="lightgray">
            Nothing to see here
          </RevaText>
          <RevaText variant="h6" fontWeight={300} maxWidth="sm" my={4} color="gray">
            Page you are trying to open does not exist. You may have mistyped the address, or the page has been moved to
            another URL. If you think this is an error contact support.
          </RevaText>
          <Button variant="contained" size="large" href="/">
            Take me to homepage
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
